/* Snyora — sticky Buy Now.
   Wokiee's own sticky button only scrolls back up to the form; this adds a real
   "buy now" that posts the selected variant to the cart and goes to checkout. */
class SnyoraStickyBuy extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector('[data-buy]');
    this.priceEl = this.querySelector('[data-sticky-price]');
    if (this.btn) this.btn.addEventListener('click', this.onClick.bind(this));
    this.watchPrice();
  }

  get form() {
    const wrap = document.getElementById(`product-form-${this.dataset.section}`);
    return (wrap && wrap.querySelector('form')) || document.querySelector('product-form form');
  }

  /* keep the sticky price in sync with the main price block on variant change */
  watchPrice() {
    if (!this.priceEl) return;
    const source = document.getElementById(`price-${this.dataset.section}`);
    if (!source) { this.priceEl.remove(); return; }
    const sync = () => {
      const txt = (source.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt) this.priceEl.textContent = txt.split(' ').slice(0, 4).join(' ');
    };
    sync();
    new MutationObserver(sync).observe(source, { childList: true, subtree: true, characterData: true });
  }

  onClick() {
    const form = this.form;
    if (!form || this.btn.getAttribute('aria-disabled') === 'true') return;
    const id = form.querySelector('[name="id"]');
    if (!id || !id.value) { this.scrollToForm(); return; }

    this.btn.setAttribute('aria-disabled', 'true');
    this.btn.classList.add('loading');

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: new FormData(form)
    })
      .then((r) => r.json())
      .then((res) => {
        if (res.status) throw new Error(res.description || res.message || 'add-to-cart failed');
        const root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
        window.location.href = `${root}/checkout`;
      })
      .catch(() => {
        /* never leave the shopper stuck — fall back to the normal add-to-cart */
        this.btn.removeAttribute('aria-disabled');
        this.btn.classList.remove('loading');
        const add = form.querySelector('[name="add"]');
        if (add) add.click(); else this.scrollToForm();
      });
  }

  scrollToForm() {
    const el = document.getElementById(`product-form-${this.dataset.section}`) ||
               document.getElementById('product-container');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
customElements.define('snyora-sticky-buy', SnyoraStickyBuy);
